'use client'
import { Image } from '@/components'
import { E_COMMERCE_PLATFORM_SHOP, FACEBOOK_APP_ID } from '@/constants/social'
import { URL_ICON } from '@/constants/ui'
import { useProductDetailV2State } from '@/features/products/contexts/product-detail'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import ShareIcon from '@mui/icons-material/Share'
import {
  Alert,
  Box,
  Button,
  ListItemText,
  MenuItem,
  Snackbar,
  Stack,
  styled,
  Typography,
  useMediaQuery,
} from '@mui/material'
import Menu from '@mui/material/Menu'
import Link from 'next/link'
import React, { useState } from 'react'
import { FacebookMessengerShareButton, FacebookShareButton } from 'react-share'

function ListButtonLinks() {
  const { product } = useProductDetailV2State()
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const [openSnackbar, setOpenSnackbar] = useState(false)
  const open = Boolean(anchorEl)
  const isMobile = useMediaQuery((theme: any) => theme.breakpoints.down('sm'))
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }
  const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text).then(() => {
      setOpenSnackbar(true)
    })
  }
  const url = typeof window !== 'undefined' ? window.location.href : ''

  return (
    <Stack direction={'row'} gap={1}>
      <Link
        href={product?.link_shopee || E_COMMERCE_PLATFORM_SHOP?.shopee}
        target="_blank"
        rel="noopener noreferrer nofollow"
        style={{ flex: 1 }}
      >
        <ButtonStyled variant="outlined" fullWidth>
          <Image
            src={URL_ICON + 'ic-shopee.svg'}
            ratio={'1/1'}
            alt="Icon Button"
            style={{ width: '16px', height: '16px' }}
          />
          <Typography
            variant="button"
            sx={{
              fontWeight: 600,
              borderRadius: '999px',
              fontSize: 'inherit',
            }}
          >
            SHOPEE
          </Typography>
        </ButtonStyled>
      </Link>

      <Link
        href={
          product?.link_tiktok || isMobile
            ? E_COMMERCE_PLATFORM_SHOP?.tiktok_shop
            : E_COMMERCE_PLATFORM_SHOP?.tiktok
        }
        rel="noopener noreferrer nofollow"
        target="_blank"
        style={{ flex: 1 }}
      >
        <ButtonStyled variant="outlined" fullWidth>
          <Image
            src={URL_ICON + 'ic-tiktok.svg'}
            ratio={'1/1'}
            alt="Icon Button"
            style={{ width: '16px', height: '16px' }}
          />
          <Typography
            variant="button"
            sx={{
              fontWeight: 600,
              borderRadius: '999px',
              fontSize: 'inherit',
            }}
          >
            TIKTOK
          </Typography>
        </ButtonStyled>
      </Link>

      <Box style={{ display: 'block', flex: 1 }}>
        <ButtonStyled variant="outlined" fullWidth onClick={handleClick}>
          <ShareIcon fontSize="small" />
          <Typography
            variant="button"
            sx={{
              fontWeight: 600,
              borderRadius: '999px',
              fontSize: 'inherit',
            }}
          >
            CHIA SẺ
          </Typography>
        </ButtonStyled>
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          disablePortal
        >
          <MenuItem onClick={handleClose}>
            <FacebookShareButton url={url} hashtag="#hydra">
              <ListItemText>Chia sẻ qua Facebook</ListItemText>
            </FacebookShareButton>
          </MenuItem>
          <MenuItem onClick={handleClose}>
            <FacebookMessengerShareButton url={url} appId={FACEBOOK_APP_ID}>
              <ListItemText>Chia sẻ qua Messenger</ListItemText>
            </FacebookMessengerShareButton>
          </MenuItem>
          <MenuItem
            onClick={() => {
              copyToClipboard(url)
              handleClose()
            }}
            sx={{ gap: 1 }}
          >
            <ListItemText sx={{ width: 'fit-content', flex: 'unset' }}>Copy link</ListItemText>
            <ContentCopyIcon fontSize="small" />
          </MenuItem>
        </Menu>
      </Box>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={2000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={() => setOpenSnackbar(false)}
          severity="success"
          variant="filled"
          sx={{ width: '100%', borderRadius: '10px', backgroundColor: 'primary.main', color: '#fff' }}
        >
          Đã sao chép liên kết!
        </Alert>
      </Snackbar>
    </Stack>
  )
}

export default ListButtonLinks
const ButtonStyled = styled(Button)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  borderRadius: '999px',
  textTransform: 'none',

  fontSize: '0.875rem',
  [theme.breakpoints.up('sm')]: {
    fontSize: '1rem',
  },

  padding: '8px',
  [theme.breakpoints.up('sm')]: {
    padding: '12px',
  },
}))
